//----------------------------------------START GLOBAL FUNCTIONS--------------------------------------//
//fire to ClickStream API
fireToMarketingCsAPI = function () {
    var data = JSON.stringify(marketingClickStream);
    var xhr = new XMLHttpRequest();
    var url = "";
    if (window.location.hostname === 'localhost' || window.location.hostname === 'localhost.prudential.com' || window.location.hostname.includes('.dev.')) {
        url = "/co/dev/secure/clickstream/v1/clickstream/";
    }
    else if (window.location.hostname.includes('.qa.')) {
        url = "/co/qa/secure/clickstream/v1/clickstream/";
    }
    else if (window.location.hostname.includes('.stage.')) {
        url = "/co/stage/secure/clickstream/v1/clickstream/";
    }
    else {
        url = "/co/prod/secure/clickstream/v1/clickstream/";
    }
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(data);
};
//get currentDdo Object from session storage
var currentDdoObj = JSON.parse(sessionStorage.getItem('currentDdo'));
//getTimeStamp of banner load
getMarketingTimeStamp = function () {
    var d = new Date();
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + (d.getDate())).slice(-2) + ' ' + ('0' + (d.getHours())).slice(-2) + ':' + ('0' + (d.getMinutes())).slice(-2) + ':' + ('0' + (d.getSeconds())).slice(-2);
};
processMarketingUTMParams = function () {
    var url = window.location.href;
    var utmParams = getMarketingUtmParams(url);
    return JSON.stringify(utmParams);
};
/*function getUtmParams(url) {
    var utmParams = {};
    var urlParams = getUrlParams(url);

    for (var key in urlParams) {
        // check if the property/key is defined in the object itself, not in parent
        if (urlParams.hasOwnProperty(key) && (isUTMParam(key) || isPresentMasterKey(key))) {
            utmParams[key] = urlParams[key];
        }
    }
    return utmParams;
}*/
function getMarketingUtmParams(url) {
    var utmParams = {};
    var urlParams = getMarketingUrlParams(url);
    var foundUTM = 0;
    for (var key in urlParams) {
        // check if the property/key is defined in the object itself, not in parent
        if (urlParams.hasOwnProperty(key) && (isMarketingUTMParam(key) || isMarketingPresentMasterKey(key))) {
            utmParams[key] = urlParams[key];
            foundUTM = 1;
        }
    }
    // THIS IS TEMP SOLUTION to fetch UTM from localstorage if not found in the URL as LINK redirects before the clickstream triggers due to 1 sec settimeout
    if (foundUTM == 0) {
        var paramsFromLS = localStorage.getItem('CMPG_PROMOSOURCE');
        console.log("Existing UTM Params found : " + paramsFromLS);
        if (paramsFromLS !== null) {
            localStorage.removeItem('CMPG_PROMOSOURCE');
            utmParams = JSON.parse(paramsFromLS);
        }
    }
    return utmParams;
}
function getMarketingUrlParams(url) {
    var vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}
function isMarketingUTMParam(key) {
    return key ? key.indexOf('utm_') === 0 : false;
}
function isMarketingPresentMasterKey(key) {
    return key === 'Co';
}
function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
// then to call it, plus stitch in '4' in the third group
guid = (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
//ip address
/* findIP = new Promise(r => {
    var w = window,
        a = new(w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({
            iceServers: []
        }),
        b = () => {};
    a.createDataChannel("");
    a.createOffer(c => a.setLocalDescription(c, b, b), b);
    a.onicecandidate = c => {
        try {
            c.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g).forEach(r)
        } catch (e) {}
    }
}); */
//getBrowserInfo
window.nVer = navigator.appVersion;
window.nAgt = navigator.userAgent;
window.browserName = navigator.appName;
window.fullVersion = '' + parseFloat(navigator.appVersion);
var nameOffset, verOffset, ix;
// In Opera 15+, the true version is after "OPR/"
if ((verOffset = nAgt.indexOf("OPR/")) != -1) {
    browserName = "Opera";
    fullVersion = nAgt.substring(verOffset + 4);
}
// In older Opera, the true version is after "Opera" or after "Version"
else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
    browserName = "Opera";
    fullVersion = nAgt.substring(verOffset + 6);
    if ((verOffset = nAgt.indexOf("Version")) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
}
// In MSIE, the true version is after "MSIE" in userAgent
else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
    browserName = "Microsoft Internet Explorer";
    fullVersion = nAgt.substring(verOffset + 5);
}
// In Chrome, the true version is after "Chrome"
else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
    browserName = "Chrome";
    fullVersion = nAgt.substring(verOffset + 7);
}
// In Safari, the true version is after "Safari" or after "Version"
else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
    browserName = "Safari";
    fullVersion = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf("Version")) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
}
// In Firefox, the true version is after "Firefox"
else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
    browserName = "Firefox";
    fullVersion = nAgt.substring(verOffset + 8);
}
// In most other browsers, "name/version" is at the end of userAgent
else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
    (verOffset = nAgt.lastIndexOf('/'))) {
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);
    if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
    }
}
// trim the fullVersion string at semicolon/space if present
if ((ix = fullVersion.indexOf(";")) != -1)
    fullVersion = fullVersion.substring(0, ix);
if ((ix = fullVersion.indexOf(" ")) != -1)
    fullVersion = fullVersion.substring(0, ix);
//Browser Width & Height
var browserSize = {
    width: window.innerWidth || document.body.clientWidth,
    height: window.innerHeight || document.body.clientHeight
};
//Operating System
var operatingSystem = "unknown";
var clientStrings = [
    { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
    { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
    { s: 'Windows Vista', r: /Windows NT 6.0/ },
    { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
    { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
    { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
    { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
    { s: 'Windows 98', r: /(Windows 98|Win98)/ },
    { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
    { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
    { s: 'Windows CE', r: /Windows CE/ },
    { s: 'Windows 3.11', r: /Win16/ },
    { s: 'Android', r: /Android/ },
    { s: 'Open BSD', r: /OpenBSD/ },
    { s: 'Sun OS', r: /SunOS/ },
    { s: 'Linux', r: /(Linux|X11)/ },
    { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
    { s: 'Mac OS X', r: /Mac OS X/ },
    { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
    { s: 'QNX', r: /QNX/ },
    { s: 'UNIX', r: /UNIX/ },
    { s: 'BeOS', r: /BeOS/ },
    { s: 'OS/2', r: /OS\/2/ },
    { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
];
for (var id in clientStrings) {
    var cs = clientStrings[id];
    if (cs.r.test(nAgt)) {
        window.operatingSystem = cs.s;
        break;
    }
}
//getParameterByName
getParameterByName = function (name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
//userssoid
//ssoidtype
getSSoIdDetails = function () {
    window.pruID = "";
    window.retirementID = "";
    window.annuitiesID = "";
    window.pruonlineID = "";
    window.groupID = "";
    if (JSON.parse(window.sessionStorage.getItem("currentDdo"))) {
        var currDDO = JSON.parse(window.sessionStorage.getItem("currentDdo"));
        var userProf = currDDO.user.profile.profileInfo;
        window.pruID = userProf.pruId;
        var legacyProf = userProf.legacyssoId;
        // Next line edited 5/2/2018 as userProf.legacyssoId is sometimes undefined in QA environment, and doing split() on it caused an error
        //if (legacyProf !== "") {
        if (legacyProf) {
            var legacyIDList = legacyProf.split("|");
            for (var i = 0; i < legacyIDList.length; i++) {
                if (legacyIDList[i].indexOf(":") > -1) {
                    var legacyItem = legacyIDList[i].split(":");
                    if ((legacyItem[1] !== undefined) && (legacyItem[1] !== "null")) {
                        var legacyID = legacyItem[1].replace(/[^a-zA-Z0-9]/g, "");
                        if (isNaN(legacyID.slice(0, 1))) {
                            legacyID = legacyID.slice(0, 7);
                        }
                        switch (legacyItem[0].toLowerCase()) {
                            case "r":
                                window.retirementID = legacyID;
                                break;
                            case "a":
                                window.annuitiesID = legacyID;
                                break;
                            case "p":
                                window.pruonlineID = legacyID;
                                break;
                            case "g":
                                window.groupID = legacyID;
                                break;
                        }
                    }
                }
            }
        }
    }
    if ((window.pruID === "") || (window.pruID === undefined)) {
        window.pruID = (function () {
            if (document.getElementById("ddo.user.profile.profileInfo.pruId")) {
                var el = document.getElementById("ddo.user.profile.profileInfo.pruId");
                var text = typeof el.textContent === 'string' ? el.textContent : el.innerText;
                if ((text !== "") && (text !== "null")) {
                    text = text.replace(/[^a-zA-Z0-9]/g, "");
                    if (isNaN(text.slice(0, 1))) {
                        text = text.slice(0, 7);
                    }
                    return text;
                }
            }
            return "";
        })();
    }
    var legacyTag = "";
    if (document.getElementById("ddo.user.profile.profileInfo.legacyssoId")) {
        var el = document.getElementById("ddo.user.profile.profileInfo.legacyssoId");
        legacyTag = typeof el.textContent === 'string' ? el.textContent : el.innerText;
    }
    if (((window.retirementID === "") || (window.retirementID === undefined)) && (legacyTag.indexOf("r:") > -1)) {
        //        var rStr = legacyTag.indexOf("r:") + 2;
        //        window.retirementID = legacyTag.substring(rStr, (legacyTag.substring(rStr).indexOf("|") > -1) ? (rStr + legacyTag.substring(rStr).indexOf("|")) : legacyTag.length);
        window.retirementID = (legacyTag.match(new RegExp('r:([^|]*)')) === null) ? "" : legacyTag.match(new RegExp('r:([^|]*)'))[1];
    }
    if (((window.annuitiesID === "") || (window.annuitiesID === undefined)) && (legacyTag.indexOf("a:") > -1)) {
        //        var aStr = legacyTag.indexOf("a:") + 2;
        //        window.annuitiesID = legacyTag.substring(aStr, (legacyTag.substring(aStr).indexOf("|") > -1) ? (aStr + legacyTag.substring(aStr).indexOf("|")) : legacyTag.length);
        window.annuitiesID = (legacyTag.match(new RegExp('a:([^|]*)')) === null) ? "" : legacyTag.match(new RegExp('a:([^|]*)'))[1];
    }
    if (((window.pruonlineID === "") || (window.pruonlineID === undefined)) && (legacyTag.indexOf("p:") > -1)) {
        //        var pStr = legacyTag.indexOf("p:") + 2;
        //        window.pruonlineID = legacyTag.substring(pStr, (legacyTag.substring(pStr).indexOf("|") > -1) ? (pStr + legacyTag.substring(pStr).indexOf("|")) : legacyTag.length);
        window.pruonlineID = (legacyTag.match(new RegExp('p:([^|]*)')) === null) ? "" : legacyTag.match(new RegExp('p:([^|]*)'))[1];
    }
    if (((window.groupID === "") || (window.groupID === undefined)) && (legacyTag.indexOf("g:") > -1)) {
        //        var gStr = legacyTag.indexOf("g:") + 2;
        //        window.groupID = legacyTag.substring(gStr, (legacyTag.substring(gStr).indexOf("|") > -1) ? (gStr + legacyTag.substring(gStr).indexOf("|")) : legacyTag.length);
        window.groupID = (legacyTag.match(new RegExp('g:([^|]*)')) === null) ? "" : legacyTag.match(new RegExp('g:([^|]*)'))[1];
    }
    if ((window.retirementID === "") || (window.retirementID === undefined) || (window.annuitiesID === "") || (window.annuitiesID === undefined)) {
        if (document.getElementById("ddo.user.profile.profileInfo.ssoId")) {
            var el = document.getElementById("ddo.user.profile.profileInfo.ssoId");
            var text = typeof el.textContent === 'string' ? el.textContent : el.innerText;
            if ((text !== "") && (text !== "null")) {
                var id = text.replace(/[^a-zA-Z0-9]/g, "");
                if (isNaN(id.slice(0, 1))) {
                    id = id.slice(0, 7);
                }
                if (window.location.pathname.indexOf("/myaccounts/annuities") > -1) {
                    //                    if (window.annuitiesID === "") {
                    //                        window.annuitiesID = id;
                    if (window.pruID === "") {
                        window.pruID = id;
                    }
                }
                else {
                    if (window.location.hostname.indexOf("retirement") > -1) {
                        if (window.retirementID === "") {
                            window.retirementID = id;
                        }
                    }
                }
            }
        }
    }
    if (window.pruDDO !== undefined) {
        if ((window.location.hash.indexOf("#/eoi") === 0) || (window.location.hash.indexOf("#/absence") === 0)) {
            if ((window.pruDDO.userData.ssoId !== undefined) && (window.pruDDO.userData.ssoId !== null)) {
                window.groupID = window.pruDDO.userData.ssoId;
            }
        }
    }
    var uInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (uInfo != null || uInfo != undefined) {
        window.pruID = uInfo.s;
        window.pruID_Override = uInfo.s;
    }
    if (window.pruID_Override !== undefined) {
        window.pruID = window.pruID_Override;
    }
    if (window.retirementID_Override !== undefined) {
        window.retirementID = window.retirementID_Override;
    }
    if (window.annuitiesID_Override !== undefined) {
        window.annuitiesID = window.annuitiesID_Override;
    }
    if (window.pruonlineID_Override !== undefined) {
        window.pruonlineID = window.pruonlineID_Override;
    }
    if (window.groupID_Override !== undefined) {
        window.groupID = window.groupID_Override;
    }
    marketingClickStream.userssoid = typeof window.pruID !== "undefined" && window.pruID !== "" ? window.pruID : window.pruonlineID !== "undefined" && window.pruonlineID !== "" ? window.pruonlineID : window.retirementID !== "undefined" && window.retirementID !== "" ? window.retirementID : window.annuitiesID !== "undefined" && window.annuitiesID !== "" ? window.annuitiesID : window.groupID !== "undefined" && window.groupID !== "" ? window.groupID : "";
    window.pruID != "" ? window.pruID : window.pruonlineID != "" ? window.pruonlineID : window.retirementID != "" ? window.retirementID : window.annuitiesID != "" ? window.annuitiesID : window.groupID != "" ? window.groupID : "";
};
//Function to get couserid
getCoUserId = function () {
    var couserId = "";
    window.couserId = "";
    if (JSON.parse(window.sessionStorage.getItem("currentDdo"))) {
        var currentUserObj = JSON.parse(window.sessionStorage.getItem("currentDdo"));
        var userProf = currentUserObj.user.profile.profileInfo;
        window.couserId = userProf.coUserId;
    }
    couserId = typeof window.couserId !== "undefined" && window.couserId !== "" ? window.couserId : "";
    return couserId;
};
//global getCookie function
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
//usertype
marketingClickStreamUserType = getCookie("p_u") != null && getCookie("p_u") != "undefined" ? "customer" : "prospect";
//clickStreamCategory
marketingClickStreamCategory = "";
if (currDDO != null) {
    document.location.pathname.indexOf("home-page") >= 0 || document.location.pathname.indexOf("/personal") >= 0 ? clickStreamCategory = "homepage" : "";
    if (JSON.parse(sessionStorage.getItem("currentDdo"))) {
        var currDDO = JSON.parse(sessionStorage.getItem("currentDdo"));
        if (currDDO.page.pageInfo != undefined) {
            var pageId = currDDO.page.pageInfo.pageId;
        }
        var pageType = currDDO.page.category.pageType;
    }
    if (document.location.pathname.indexOf('mfl') >= 0) {
        if (document.location.pathname == "/mfl/") {
            marketingClickStreamCategory = "My Financial Life-Homepage";
        }
    }
    else if (pageId) {
        if (pageId.indexOf('fe') >= 0) {
            if (pageId.indexOf('fe.home') >= 0) {
                marketingClickStreamCategory = "FE-Homepage";
            }
            else if (pageId.indexOf('article') >= 0) {
                if (jQuery('#nav-level3 .navpane li.active').text().replace(/^\s+|\s+$/g, "") != "") {
                    marketingClickStreamCategory = "FE-" + jQuery('#nav-level3 .navpane li.active').text().replace(/^\s+|\s+$/g, "");
                }
                else if (jQuery('.article-detail .h1').text().replace(/^\s+|\s+$/g, "") != "") {
                    marketingClickStreamCategory = "FE-" + jQuery('.article-detail .h1').text().replace(/^\s+|\s+$/g, "");
                }
            }
        }
        else if (pageId.indexOf('fw') >= 0) {
            if (pageId.indexOf('fw.home') >= 0) {
                marketingClickStreamCategory = "FW-Homepage";
            }
            else if (pageId.indexOf('article') >= 0) {
                if (jQuery('#nav-level3 .navpane li.active').text().replace(/^\s+|\s+$/g, "") != "") {
                    marketingClickStreamCategory = "FW-" + jQuery('#nav-level3 .navpane li.active').text().replace(/^\s+|\s+$/g, "");
                }
                else if (jQuery('.article-detail .h1').text().replace(/^\s+|\s+$/g, "") != "") {
                    marketingClickStreamCategory = "FW-" + jQuery('.article-detail .h1').text().replace(/^\s+|\s+$/g, "");
                }
            }
        }
    }
}
if (marketingClickStreamCategory == "") {
    if (pageType) {
        if (pageType == "My Accounts") {
            marketingClickStreamCategory = "My Accounts";
        }
    }
}
function getEventParams(contentId, type, userAction, count, component, label, destinationurl) {
    var eventParametersList = [];
    var eventParameters = {};
    eventParameters.type = type;
    eventParameters.userAction = userAction;
    eventParameters.count = count;
    eventParameters.timestamp = getMarketingTimeStamp();
    eventParameters.contentId = contentId;
    eventParameters.revisionNumber = "";
    eventParameters.couserId = getCoUserId();
    eventParameters.component = component;
    eventParameters.label = label;
    eventParameters.destinationurl = destinationurl;
    eventParametersList.push(JSON.stringify(eventParameters));
    return eventParametersList;
}
//-------------------------------------------END GLOBAL FUNCITONS--------------------------------//
//-------------------------------------------START PAGE_VIEW & CUSTOM_EVENT FUNCTIONS------------------//
marketing_view = function (contentId) {
    (function () {
        // clickStream.label = document.location.href;
        // Populating UTM Params, referrer and guid in 'clickStream' object
        marketingClickStream.utmparams = processMarketingUTMParams();
        marketingClickStream.visitorid = getCookie("X-PruGlobalSessionID");
        marketingClickStream.utmuuid = getCookie("uuid");
        marketingClickStream.referrer = escape(document.referrer);
        marketingClickStream.utmtrackerflag = "Y";
        marketingClickStream.guid = getCookie("_gid") != null && getCookie("_gid") != "undefined" ? getCookie("_gid") : ""; //_gid;
        marketingClickStream.eventTypes = "DISPLAY";
        var component = "Marketing_Messages_Banner";
        var label = document.location.href;
        var destinationUrl = "";
        marketingClickStream.eventParams = getEventParams(contentId, 'PAGE_LOAD', 'display', '1', component, label, destinationUrl);
        console.log('  ## DEMS utmparams       :::::' + marketingClickStream.utmparams);
        console.log('  ## DEMS _gid            :::::' + marketingClickStream.guid);
        console.log(' ## DEMS referrer        :::::' + marketingClickStream.referrer);
        console.log(' ##DEMS  utmtrackerflag  :::::' + marketingClickStream.utmtrackerflag);
        console.log(' ##DEMS currentddo:::::' + window.sessionStorage.getItem('currentDdo'));
        // Calling the clickstream API
        //window.sessionStorage.setItem("pageLoaded", null);
        getSSoIdDetails();
        fireToMarketingCsAPI();
    })();
};
//-------------------------------------------END PAGE_VIEW & CUSTOM_EVENT FUNCTIONS------------------//
//--------------------------------------------START DEFINING CLICK STREAM OBJECT & FIRING PAGEVIEW-----------------------------//
marketingClickStream = {};
marketingClickStream.timestamp = getMarketingTimeStamp(); //"Tue, 26 Jun 2018 16:16:12 GMT"
if (typeof visitor !== "undefined") {
    if (typeof visitor._fields !== "undefined") {
        marketingClickStream.mcvisid = visitor._fields.MCMID;
    }
}
marketingClickStream.infintiteId = "";
marketingClickStream.sessionid = typeof currentDdoObj !== "undefined" && currentDdoObj !== null ? currentDdoObj.user.profile.profileInfo.sessionId : "";
marketingClickStream.usertype = marketingClickStreamUserType;
marketingClickStream.userrole = typeof currentDdoObj !== "undefined" && currentDdoObj !== null ? currentDdoObj.user.profile.profileInfo.userRole : "";
marketingClickStream.ssoidtype = "";
marketingClickStream.uuid = getCookie("uuid") != null && getCookie("uuid") != "undefined" ? getCookie("uuid") : "";
marketingClickStream.pagename = document.location.origin + document.location.pathname;
marketingClickStream.title = document.title;
marketingClickStream.component = "";
//clickStream.destinationurl ="";
marketingClickStream.marketing_channel = "";
marketingClickStream.domain = document.location.host;
marketingClickStream.referrer = document.referrer;
marketingClickStream.browser = browserName;
marketingClickStream.browserversion = fullVersion;
marketingClickStream.browserheight = browserSize.height;
marketingClickStream.browserwidth = browserSize.width;
marketingClickStream.campaignname = getParameterByName("intcmp") != null ? getParameterByName("intcmp") : getParameterByName("utm_source") == "eloqua" ? getParameterByName("utm_campaign") : "";
marketingClickStream.cookies = navigator.cookieEnabled;
marketingClickStream.os = window.operatingSystem;
marketingClickStream.eloquaid = getParameterByName("elqcid") != null ? getParameterByName("elqcid") : "";
marketingClickStream.eventParams = [];
marketingClickStream.eventTypes = "";
//--------------------------------------------END DEFINING CLICK STREAM OBJECT & FIRING PAGEVIEW-----------------------------//
//-----------------------------------------------START Marketing Messages widget TRACKING------------------------------------------------//
//Retrieve clickstream properties for click event   
setClickStreamPropertiesForClick = function (inputThis, componentName) {
    var component = componentName;
    var label = jQuery(inputThis).text().replace(/^\s+|\s+$/g, "");
    var destinationurl = jQuery(inputThis).attr('href');
    var contentId = jQuery(inputThis).find('input:hidden').attr('value');
    marketingClickStream.eventTypes = "CLICK";
    marketingClickStream.eventParams = getEventParams(contentId, 'CLICK', 'button_click', '1', component, label, destinationurl);
    fireToMarketingCsAPI();
};
//Fire Custom Event With Banner Details
fireMarketingCustomEvent = function () {
    var tempTitle = jQuery('.mmm-container').find('h2').map(function () {
        return jQuery(this).text();
    }).get();
    var title = tempTitle.join('|');
    var tempPara = jQuery('.mmm-container').find('p').map(function () {
        return jQuery(this).text();
    }).get();
    var content = tempPara.join('|');
    var CTAText = jQuery('.mmm-container').find('a').map(function () {
        return jQuery(this).text();
    }).get();
    var bannerCTAText = CTAText.join('|');
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent('marketingBanner', false, false, {
        screenName: document.title,
        bannerTitle: title,
        bannerContent: content,
        bannerCTA: bannerCTAText
    });
    document.dispatchEvent(evt);
    //Need to cleaned up
    console.log('Screen Name######' + document.title);
    console.log('BannerTitle#####' + title);
    console.log('BannerContent#####' + content);
    console.log('BannerCTA####' + bannerCTAText);
};
//-----------------------------------------------END Marketing Messages Widget TRACKING------------------------------------------------//
//# sourceMappingURL=MarketingClickStream.js.map